"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePassengersAges = exports.reservationValidationText = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
exports.reservationValidationText = {
    negativePassengers: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/ReservationValidation:negativePassengerCount', defaultMessage: 'The number of passengers should not be negative' })),
    tooManyInfants: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/ReservationValidation:tooManyInfants', defaultMessage: 'The number of infants should not exceed the number of adults' })),
    zeroPassengers: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/ReservationValidation:zeroPassengers', defaultMessage: 'The number of passengers should not be zero' })),
};
const validatePassengersAges = (ages) => {
    const { adult, child, infant } = ages;
    if (adult < 0 || child < 0 || infant < 0) {
        return exports.reservationValidationText.negativePassengers;
    }
    if (adult < infant) {
        return exports.reservationValidationText.tooManyInfants;
    }
    if (adult === 0 && child === 0) {
        return exports.reservationValidationText.zeroPassengers;
    }
    return undefined;
};
exports.validatePassengersAges = validatePassengersAges;
//# sourceMappingURL=reservation.js.map